import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "download-animation-badge"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-center py-2"
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.downloadAnimation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_menu, {
      modelValue: _ctx.showToolTip,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showToolTip) = $event)),
      "offset-x": "",
      location: "bottom"
    }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_menu, {
      "offset-y": "",
      modelValue: _ctx.menuIsOpen,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menuIsOpen) = $event)),
      "close-on-click": true,
      "close-on-content-click": false,
      location: "bottom"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          icon: " $oss-bell ",
          color: "primary"
        }, props), null, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_row, { style: {"background":"#fff","width":"500px","box-shadow":"0px 4px 16px rgba(0, 0, 0, 0.2)","border-radius":"8px","background-color":"white"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex align-center title py-3 px-4 font-weight-medium"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Notifications ")
              ])),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.step,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step) = $event)),
                  "fixed-tabs": "",
                  height: "36px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "ALL" }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("strong", null, "Tous", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "DOCUMENT" }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Document", -1)),
                        (_ctx.numberOfUnreadDocument !== 0)
                          ? (_openBlock(), _createBlock(_component_v_badge, {
                              key: 0,
                              content: _ctx.numberOfUnreadDocument,
                              floating: ""
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "CHAT_MESSAGE" }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Chat", -1)),
                        (_ctx.numberOfUnreadChatMessages !== 0)
                          ? (_openBlock(), _createBlock(_component_v_badge, {
                              key: 0,
                              content: _ctx.numberOfUnreadChatMessages,
                              floating: ""
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "IMPORT" }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Import", -1)),
                        (_ctx.numberOfUnreadImport !== 0)
                          ? (_openBlock(), _createBlock(_component_v_badge, {
                              key: 0,
                              content: _ctx.numberOfUnreadImport,
                              floating: ""
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "EXPORT" }, {
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Export", -1)),
                        (_ctx.numberOfUnreadExport !== 0)
                          ? (_openBlock(), _createBlock(_component_v_badge, {
                              key: 0,
                              content: _ctx.numberOfUnreadExport,
                              floating: ""
                            }, null, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "px-2 py-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { style: {"max-height":"70vh","overflow-y":"auto"} }, {
                  default: _withCtx(() => [
                    (!_ctx.filteredNotifications.length)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          class: "d-flex justify-center py-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode(" Aucune notification ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNotifications, (n, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        class: _normalizeClass(_ctx.getNotificationClass(n))
                      }, {
                        prepend: _withCtx(() => [
                          (n.icon)
                            ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(n.icon), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        append: _withCtx(() => [
                          (_ctx.isUnreadNotification(n))
                            ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                key: 0,
                                icon: "$oss-download",
                                onClick: ($event: any) => (_ctx.directDownload(n)),
                                size: "small"
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (n.scope === 'document')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("notification.document.create", n.datas.length)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n.datas.slice(0, 2), (d, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    class: "notification--sub-card",
                                    onClick: ($event: any) => (_ctx.routerPushDocument(d))
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                          _createTextVNode("$oss-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(d.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128)),
                                (n.datas.length > 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("notification.document.andMore", n.datas.length - 2, {
                                            count: n.datas.length - 2,
                                        })), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (n.scope === 'chatMessage')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_v_list_item_subtitle, { class: "pb-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(n.data.sender.firstname || "") + " " + _toDisplayString(n.data.sender.lastname || ""), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_list_item_title, { style: {"white-space":"normal"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(n.data.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              : (n.scope === 'accountingItemExport')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(_component_v_list_item_subtitle, { class: "pb-2" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(n.text), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (n.data && n.data.step < n.data.stepCount)
                                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                          key: 0,
                                          rounded: "",
                                          "model-value": (n.data.step / n.data.stepCount) * 100,
                                          location: "bottom"
                                        }, null, 8, ["model-value"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (n.scope === 'accountingItemImport')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createVNode(_component_v_list_item_subtitle, { class: "pb-2" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(n.text), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (n.data && n.data.step < n.data.stepCount)
                                        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                            key: 0,
                                            rounded: "",
                                            "model-value": (n.data.step / n.data.stepCount) * 100,
                                            location: "bottom"
                                          }, null, 8, ["model-value"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (
                                    ['invoice', 'engagementLetter', 'openPoints'].includes(n.scope)
                                )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        _createVNode(_component_v_list_item_subtitle, { class: "pb-2" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(n.text), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (n.extraData && n.extraData.step < n.extraData.stepCount)
                                          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                                              key: 0,
                                              rounded: "",
                                              "model-value": (n.extraData.step / n.extraData.stepCount) * 100,
                                              location: "bottom"
                                            }, null, 8, ["model-value"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_v_list_item_title, { key: 5 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(n.text || "") + " ", 1),
                                          (n.user)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(n.user), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "text",
                  onClick: _ctx.markAllAsRead
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      left: ""
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("$fa-check-double")
                      ])),
                      _: 1
                    }),
                    _cache[12] || (_cache[12] = _createTextVNode(" Marquer comme lu "))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}